import { lazy, Suspense } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Layout } from "@/components/layout/Layout";
import { PortalProtectedRoute } from "@/components/portal/PortalProtectedRoute";
import { HomePage } from "@/pages/HomePage";
import { PANEL_PATH } from "@/admin/types";

const CategoryPage = lazy(() =>
  import("@/pages/CategoryPage").then((m) => ({ default: m.CategoryPage })),
);
const ArticlePage = lazy(() =>
  import("@/pages/ArticlePage").then((m) => ({ default: m.ArticlePage })),
);
const SearchPage = lazy(() =>
  import("@/pages/SearchPage").then((m) => ({ default: m.SearchPage })),
);
const TagPage = lazy(() => import("@/pages/TagPage").then((m) => ({ default: m.TagPage })));
const ContactPage = lazy(() =>
  import("@/pages/ContactPage").then((m) => ({ default: m.ContactPage })),
);
const AdvertisePage = lazy(() =>
  import("@/pages/AdvertisePage").then((m) => ({ default: m.AdvertisePage })),
);
const PrivacyPage = lazy(() =>
  import("@/pages/PrivacyPage").then((m) => ({ default: m.PrivacyPage })),
);
const TermsPage = lazy(() =>
  import("@/pages/TermsPage").then((m) => ({ default: m.TermsPage })),
);
const NotFoundPage = lazy(() =>
  import("@/pages/NotFoundPage").then((m) => ({ default: m.NotFoundPage })),
);
const PortalLoginPage = lazy(() =>
  import("@/pages/PortalLoginPage").then((m) => ({ default: m.PortalLoginPage })),
);
const AdminRoutes = lazy(() =>
  import("@/admin/AdminRoutes").then((m) => ({ default: m.AdminRoutes })),
);
const ClientRoutes = lazy(() =>
  import("@/client/ClientRoutes").then((m) => ({ default: m.ClientRoutes })),
);
const SorteioPublicPage = lazy(() =>
  import("@/pages/sorteios/SorteioPublicPage").then((m) => ({ default: m.SorteioPublicPage })),
);
const SorteioPedidoPage = lazy(() =>
  import("@/pages/sorteios/SorteioPedidoPage").then((m) => ({ default: m.SorteioPedidoPage })),
);
const SorteioMeusNumerosPage = lazy(() =>
  import("@/pages/sorteios/SorteioMeusNumerosPage").then((m) => ({ default: m.SorteioMeusNumerosPage })),
);
const SorteioResultadoPage = lazy(() =>
  import("@/pages/sorteios/SorteioResultadoPage").then((m) => ({ default: m.SorteioResultadoPage })),
);

function RouteFallback() {
  return (
    <div
      className="flex min-h-[40vh] items-center justify-center text-sm text-brand-on-surface-variant"
      aria-busy="true"
    >
      Carregando…
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Suspense fallback={<RouteFallback />}>
        <Routes>
          <Route path="/entrar" element={<PortalLoginPage />} />
          <Route path="/sorteios/:slug/pedido/:id" element={<SorteioPedidoPage />} />
          <Route path="/sorteios/:slug/meus-numeros" element={<SorteioMeusNumerosPage />} />
          <Route path="/sorteios/:slug/resultado" element={<SorteioResultadoPage />} />
          <Route path="/sorteios/:slug" element={<SorteioPublicPage />} />
          <Route element={<PortalProtectedRoute />}>
            <Route element={<Layout />}>
              {/* Home eager — evita CLS do Suspense na rota principal */}
              <Route index element={<HomePage />} />
              <Route path="categoria/:slug" element={<CategoryPage />} />
              <Route path="materia/:slug" element={<ArticlePage />} />
              <Route path="tag/:slug" element={<TagPage />} />
              <Route path="busca" element={<SearchPage />} />
              <Route path="contato" element={<ContactPage />} />
              <Route path="anuncie" element={<AdvertisePage />} />
              <Route path="privacidade" element={<PrivacyPage />} />
              <Route path="termos" element={<TermsPage />} />
              <Route path="*" element={<NotFoundPage />} />
            </Route>
          </Route>
          <Route path="search" element={<Navigate to="/busca" replace />} />
          <Route path={`${PANEL_PATH}/client/*`} element={<ClientRoutes />} />
          <Route path={`${PANEL_PATH}/*`} element={<AdminRoutes />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}
